import {PaymentMethods} from "../utils/Constants";

export const typePayment = [
    { value: PaymentMethods.QR, label: PaymentMethods.QR },
    { value: PaymentMethods.TRANSACTION, label: PaymentMethods.TRANSACTION },
    { value: PaymentMethods.CASH, label: PaymentMethods.CASH },
];
